import React from 'react'
import FormFactory from '../../../../components/form/form-factory'

import { Container, Wrapper } from './styles'

type IProps = any
const RecoveryPassword = ({
  dataForm,
  onSubmit,
  errorMessage,
}: IProps): JSX.Element => (
  <Container>
    <Wrapper>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
      />
    </Wrapper>
  </Container>
)

export default RecoveryPassword
